/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import { omit } from 'lodash';
import { Text } from '@blend/enterprise-components';

import { confirmNewPassword } from 'blb-api/auth';
import { BlendBridge } from 'blb-types/blendBridge';
import { FormCard } from 'blb-components/FormCard';
import { PasswordValidity } from 'blb-components/UnauthenticatedApp/PasswordValidity';
import { passwordInputConfigWithValidation, confirmPasswordInputConfig } from 'blb-inputs/unauthenticated';
import { getConfirmationCodeInputConfig } from 'blb-utils/inputs';

const confirmationCodeInputConfig = getConfirmationCodeInputConfig({ name: 'confirmationCode' });

export namespace ResetPasswordPage {
  export interface Props {}
}

type FormValues = BlendBridge.API.ResetPasswordConfirmationBody & { confirmedPassword: string };

export const ResetPasswordPage: React.FC<ResetPasswordPage.Props> = ({}) => {
  const history = useHistory();

  const onSubmit = async (values: FormValues) => {
    await confirmNewPassword(omit(values, ['confirmedPassword']));
    history.push('/login');
  };
  return (
    <FormCard<FormValues>
      headerLabel={
        <Text>We have sent a password reset code to your email. Enter it below to reset your password.</Text>
      }
      headerTitle="Reset password"
      id="ResetPassword"
      onSubmit={onSubmit}
      submitLabel="Change password"
    >
      <Field {...confirmationCodeInputConfig} />
      <Field {...passwordInputConfigWithValidation} />
      <Field {...confirmPasswordInputConfig} />
      <PasswordValidity />
    </FormCard>
  );
};
